import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftAlign = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 9,
	viewBox: "0 0 16 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0.75 0C0.335786 0 0 0.335786 0 0.75C0 1.16421 0.335786 1.5 0.75 1.5H15.25C15.6642 1.5 16 1.16421 16 0.75C16 0.335786 15.6642 0 15.25 0H0.75Z",
			fill: "#545F7E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 9H0.75C0.335786 9 0 8.66421 0 8.25C0 7.83579 0.335786 7.5 0.75 7.5H11.25C11.6642 7.5 12 7.83579 12 8.25C12 8.66421 11.6642 9 11.25 9Z",
			fill: "#545F7E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.25 5.25H0.75C0.335786 5.25 0 4.91421 0 4.5C0 4.08579 0.335786 3.75 0.75 3.75H9.25C9.66421 3.75 10 4.08579 10 4.5C10 4.91421 9.66421 5.25 9.25 5.25Z",
			fill: "#545F7E"
		})
	]
});
const ForwardRef = forwardRef(SvgLeftAlign);
export default ForwardRef;
